<template>
  <div>
    <v-container class="global-margin">
      <v-breadcrumbs :items="breadcrumbs" class="breadcrumbs pl-0" large></v-breadcrumbs>
      <v-row align="center" justify="center">
        <v-col cols="12" md="8">
          <v-row>
            <v-col cols="12" md="9">
              <h2 class="display-2 w-100 mb-6">Nastavnik</h2>
              <h3 class="blue-text font-weight-medium pt-6" > <v-icon size="18" left color="#084776" class="pb-1">fa-list-alt</v-icon>Popis nastavnika koji su snimali video lekcije:</h3>
            </v-col>
            <v-col cols="12" md="12">

              <v-expansion-panels focusable flat hover v-for="(item, i) in teachers" :key="i">
                <v-expansion-panel class="mb-2">
                  <v-expansion-panel-header
                    class="blue-text font-weight-medium py-7 text-uppercase"
                  >{{ item.title }}</v-expansion-panel-header>
                  <v-expansion-panel-content class="py-5 pb-0">
                    <v-expansion-panels
                      focusable
                      flat
                      hover
                      v-for="(city, j) in item.schools"
                      :key="j"
                    >
                      <v-expansion-panel style class="mb-2">
                        <v-expansion-panel-header
                          class="blue-text font-weight-medium py-7 text-uppercase"
                        >{{city.name}}</v-expansion-panel-header>
                        <v-expansion-panel-content class="py-5 pb-0">
                          <div v-for="(school, k) in city.nastavnici" :key="k">
                            <v-row>
                              <v-col cols="1" sm="1">
                                <v-icon>fas fa-angle-double-right</v-icon>
                              </v-col>
                              <v-col cols="11" sm="11">
                                <p class="mb-0 pb-0">{{school.user}}</p>



                                <span class="grey--text"> <v-icon size="15" left>fas fa-video</v-icon> Broj snimljenih lekcija: {{school.broj_lekcija}}</span>
                              </v-col>
                            </v-row>
                          </div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
            <!-- <v-col cols="12" md="3"><v-btn rounded="" dark depressed="" to="/admin" color="#084776" height="50" width="150" class="text-capitalize">Prijava</v-btn></v-col> -->
          </v-row>
          <v-img :src="require('@/assets/img/vizual-skole.png')"></v-img>
          <v-row>
            <v-col cols="12" class="text-center">
              <v-btn
                rounded
                color="#084776"
                dark
                class="text-capitalize"
                href="https://www.youtube.com/watch?v=t44bPps5ftk&feature=youtu.be"
                target="_blank"
                height="50px"
              >Detaljne upute za nastvnike</v-btn>
            </v-col>
          </v-row>
          <p>
            Dragi nastavnici. Dobrodošli na digitalnu platformu za škole. Na platformi možete pronaći sve digitallne sadržaje za svaki razred osnovne i srednje škole na poveznici
            <a
              href="/lekcije"
              target="_blank"
              style="color: #084776 !important; text-decoration: none"
            >skole.sum.ba/lekcije</a> koji je kategoriziran po razredima, a zatim po predmetima. Sav sadržaj koji se ovdje nalazi dostupan je svima koji pristupaju ovoj web platformi.
          </p>
          <p>
            Važno je imati na umu da se odvijanje nastave i komunikacije u online okruženju razlikuje od
            komunikacije uživo i ima svoje zakonitosti. Ono što u komunikaciji uživo prenosimo
            neverbalnom komunikacijom poput tona glasa ili izraza lica te čujemo u grupi čak i kada
            poruka nije izravno upućena nama, u online okruženju potrebno je prenijeti pomoću drugih
            alata. Osiguravanje redovite i jasne komunikacije te jasna organizacija informacija, neki su
            od preduvjeta uspješnog poučavanja u online okruženju. Dodatno online nastava zahtijeva
            disciplinu, organiziranost i samostalnost kod učenika pri čemu učenicima, pogotovo
            mlađima, treba snažnija struktura te podrška i vodstvo nastavnika. U nastavku slijedi
            nekoliko osnovnih prijedloga nastavnicima za osiguravanje što uspješnije nastave u online
            okruženju.
          </p>
          <h2 class="title my-4" style="color: #084776;">Želite dodati nastavni sadržaj?</h2>
          <p>
            Pošaljite vaš sadržaj na mail
            <span class="font-weight-bold">sadrzaj@skole.sum.ba</span>.
            <br />Naši moderatori će sadržaj pregledati te postaviti na platofrmu ukoliko zadovoljava sve kriterije.
          </p>
        </v-col>

        <v-col cols="12" md="8" class="text-center">
          <v-img :src="require('@/assets/img/nastavnik-vizual.png')"></v-img>
          <!--<v-btn
                  rounded
                  dark
                  depressed
                  href="/admin/#/sadrzaji"
                  color="#084776"
                  height="50"
                  width="150"
                  class="text-capitalize mt-4"
          >Prijava</v-btn>-->
        </v-col>

        <v-col cols="12" md="8">
          <p>
            Kada je nastavnik uspješno dobio mail
            <b>@skole.sum.ba</b> može pristupiti i koristiti digitalnu platformu skole.sum.ba.
            <!--Svaki nastavnik može pripremati i postaviti svoj digitalni sadržaj na digitalnu platformu za škole.
            Kako bi nastavnik postavio svoje materijale i sadržaje, mora se prijaviti na sustav sa svojim korisničkim računom.
            Nakon uspješne prijave, nastavnik može pristupiti dodavanju sadržaja. Na početku bira razred, zatim odabire određeni predmet za pojedini razred,
            te na kraju može pristupiti samom dodavanju sadržaja i dodavanju kategorija unutar nekog premeta. Kada nastavnik uspješno doda svoj sadržaj,
            osoba zadužena za odobravanje sadržaja iz nadležne ustanove pregledava taj sadržaj i u ovisnosti o kvaliteti sadržaja, taj sadržaj odobrava ili odbija.
            U slučaju odobravanja taj sadržaj je automatski vidljiv na digitalnoj platformi na poveznici
            <a
              href="/lekcije"
              target="_blank"
              style="color: #084776 !important; text-decoration: none"
            >skole.sum.ba/lekcije</a>, te se nalazi u kategoriji koju je nastavnik postavi unutar administracije. U slučaju odbijanja od nadređene osobe, sadržaj neće biti vidljiv na digitalnoj platformi.
            </p>-->
          </p>
          <p>
            <!--Jednom kada se sadržaj postavi, te zatim odobri, krajnji korisnici imaju mogućnost pregleda digitalnog sadržaja prilagođenog uzrastu učenika kojeg su izradili nastavnici.-->
            Za sve poteškoće i nejasnoće obratite se Vašoj školi. Popis škola sa kontakt podacima možete pronaći na sljedećoj
            <a
              href="/kontakt"
              target="_blank"
              style="color: #084776 !important; text-decoration: none"
            >poveznici</a>.
          </p>
        </v-col>

        <v-col cols="12" md="8" v-for="(item, i) in upute" :key="i">
          <v-card flat :href="item.link">
            <v-row>
              <v-col cols="10">
                <v-card-title style="color: #084776">{{item.title}}</v-card-title>
                <v-card-subtitle>{{item.text}}</v-card-subtitle>
              </v-col>
              <v-col cols="2">
                <v-card-text>
                  <v-icon class="mt-3" color="#084776">fas fa-chevron-right</v-icon>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Nastavnik",
  data() {
    return {
      upute: [
        // {
        //   title: "Pristup administraciji za unos sadržaja",
        //   text: "Kliknite ovdje za pristup administraciji",
        //   link: "https://skole.sum.ba/admin/#/sadrzaji"
        // },
        {
          title: "Predložak za prezentciju",
          text: "Kliknite ovdje za preuzimanje predloška",
          link: "https://skole.sum.ba/admin/dokumenti/template.pptx"
        },
        {
          title: "Upute za izradu videolekcija za nastavu na daljinu",
          text: "Kliknite ovdje za preuzimanje uputa",
          link:
            "https://skole.sum.ba/admin/dokumenti/Upute_snimanje_video_lekcija.pdf"
        },
        {
          title: "Upute zakorištenje aplikacije Hangouts Meet",
          text: "Kliknite ovdje za preuzimanje uputa",
          link: "https://skole.sum.ba/admin/dokumenti/hangouts-meet.pdf"
        },
        {
          title: "Upute za G Suite",
          text: "Kliknite ovdje za pregled",
          link: "/gsuite"
        },
        {
          title: "Upute za SUMIT Školarac",
          text: "Kliknite ovdje za pregled",
          link: "/skolarac"
        }
        // {
        //   title: "Sve upute za korištenje digitalne platforme možete pronaći na YouTube kanalu",
        //   text: "Kliknite ovdje za pregled",
        //   link: "https://www.youtube.com/channel/UCgqbhSxPBuVGfAEEnxEk2cQ/featured"
        // },
      ],
      teachers: [],
      breadcrumbs: [
        {
          text: "Naslovnica",
          disabled: false,
          to: "/"
        },
        {
          text: "Nastavnik",
          disabled: true
        }
      ]
    };
  },
  mounted() {
    this.getTeachers();
  },
  methods: {
    getTeachers() {
      skoleApi.get("ostalo/nastavnici/lekcije").then(response => {
        this.teachers = response.data;
        console.log(this.teachers);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.nastavnici {
  margin-top: 150px; //CHANGE TO 150px WHEN COMING SOON IS OVER
}
@media (max-width: 768px) {
  .nastavnici {
    margin-top: 120px !important; //CHANGE TO 120px WHEN COMING SOON IS OVER
  }
}
.v-card__text,
.v-card__title {
  word-break: normal;
}
</style>
